import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "18",
  viewBox: "0 0 17 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.5 17.6841C13.1944 17.6841 17 13.8785 17 9.18408C17 4.48966 13.1944 0.684082 8.5 0.684082C3.80558 0.684082 0 4.48966 0 9.18408C0 13.8785 3.80558 17.6841 8.5 17.6841ZM8.68311 5.21729C8.68311 4.80307 8.34732 4.46729 7.93311 4.46729C7.51889 4.46729 7.18311 4.80307 7.18311 5.21729V7.49803V9.18747C7.18311 9.35793 7.24117 9.52331 7.34774 9.65635L9.6144 12.4862C9.87336 12.8095 10.3454 12.8616 10.6686 12.6027C10.9919 12.3437 11.0441 11.8717 10.7851 11.5484L8.68311 8.92413V7.49803V5.21729Z",
      fill: "#2C3647"
    }, null, -1)
  ]))]))
}
export default { render: render }